<div class="visionboard-workspace-controls">
  <div class="dropdowns"></div>

  <div class="controls">
    <span
      class="saving"
      [ngClass]="{ failedToSave: failedToSave }"
      >{{ saveText }}</span
    >
    <app-visionboard-workspace-favorites-button-menu-learn-more
      *ngIf="!mobileView"
    ></app-visionboard-workspace-favorites-button-menu-learn-more>
    <app-visionboard-workspace-favorites-button-menu *ngIf="!isGuestUser"></app-visionboard-workspace-favorites-button-menu>
    <app-visionboard-workspace-mode-toggle></app-visionboard-workspace-mode-toggle>
  </div>
</div>
